import React from 'react'
import { Field } from 'formik'
import { InputWrapper, Label, Error } from './styles'
import './index.css'

const FieldComponent = ({
  name,
  placeholder,
  label,
  error,
  labelWhite,
  historic,
  ...props
}) => {
  return (
    <InputWrapper historic={historic}>
      {label && <Label white={labelWhite}>{label}:</Label>}
      <Field
        className={`input-field ${historic ? 'input-field-historic' : ''}`}
        name={name}
        placeholder={placeholder}
        {...props}
      />
      {error && <Error>{error}</Error>}
    </InputWrapper>
  )
}

export default FieldComponent
